// Account Activity timeline — TanStack Query hooks.

import {
  useInfiniteQuery,
  type UseInfiniteQueryResult,
} from "@tanstack/react-query";

import {
  fetchAccountActivity,
  type AccountActivityKind,
  type AccountActivityPage,
} from "./activityApi";


export const ACCOUNT_ACTIVITY_QUERY_KEY = "account-activity" as const;


export function useAccountActivityInfinite(
  accountId: string | undefined,
  kinds: AccountActivityKind[] | undefined = undefined,
): UseInfiniteQueryResult<{ pages: AccountActivityPage[] }, Error> {
  const stableKinds = (kinds ?? []).slice().sort();
  return useInfiniteQuery({
    queryKey: [
      ACCOUNT_ACTIVITY_QUERY_KEY, accountId, stableKinds,
    ],
    enabled: Boolean(accountId),
    initialPageParam: null as string | null,
    queryFn: ({ pageParam, signal }) =>
      fetchAccountActivity(
        {
          accountId: accountId!,
          cursor: pageParam as string | null,
          kinds: stableKinds.length ? stableKinds : undefined,
        },
        { signal },
      ),
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
  });
}
